/* eslint-disable import/named */
/* eslint-disable flowtype/require-return-type */
// @flow
import React from 'react';

import { getProjectDelayListApi } from '../../apis';
import { delayReasons, getBaseDomainUrl } from '../../constants';

import '../../index.css';
import './index.css';


type Props = {
  projectId: number;
  companyId: number;
  disciplineId: string;
}

type State = {
  data: any;
  isLoading: boolean;
}

type WorkflowName = {
  id: string;
  isoNumber: string;
  name: string;
  serialNo: String;
}

class ProjectDelay extends React.Component<Props, State> {
  state = {
    data: null,
    isLoading: false,
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.disciplineId !== prevProps.disciplineId) {
      this.fetchData();
    }
  }

  fetchData = async (): any => {
    try {
      this.setState({
        isLoading: true,
      });

      const response: any = await (getProjectDelayListApi(
        { projectId: this.props.projectId, companyId: this.props.companyId, disciplineId: this.props.disciplineId },
      ));
      if (response.status === 200) {
        this.setState({
          isLoading: false,
          data: response.data,
        });
      }
    } catch (e) {
      this.setState({
        isLoading: false,
      });
    }
  }

  getParentHierarchy(
    activity: any | null,
  ): React.ReactNode {
    if (!activity || !activity.parentChain) return '';
    const parents: Array<string> = activity.parentChain.split(' | ').reverse();
    return parents.join(' > ');
  }

  getFormattedReason(reason: string[]): string {
    return delayReasons.find((r: any) => r.value === reason) ? delayReasons.find((r: any) => r.value === reason).label : reason;
  }

  getReasonList(reasons: string[]): string {
    const reasonList: string[] = reasons
      ? reasons.map((reason: string): string => this.getFormattedReason(reason)) : [];
    return reasonList.join(', ') === '' ? 'NA' : reasonList.join(', ');
  }

  openWorkflow(id: string) {
    /* eslint-disable */
    if (this.props.projectId !== undefined && this.props.projectId !== null) {
      window.open(`${getBaseDomainUrl()}/c/${this.props.companyId}/projects/${this.props.projectId}/flow/instance/${id}`, "_blank");
    }
  }

  getAnchoredData(data: any, id: string): any {
    return <a className="anchorTag" onClick={this.openWorkflow.bind(this, id)}>{data}</a>;
  }

  getWorkflowDetails(names: WorkflowName[]): string {
    const filteredNames: WorkflowName[] = (names || []).filter((name: WorkflowName) => name.serialNo && name.isoNumber);
    if (filteredNames.length === 0) {
      return 'NA';
    }

    const workflowNames: string[] = filteredNames.reduce((a: string, item: WorkflowName, index: number) => {
      a.push(this.getAnchoredData(`${item.serialNo} ${item.isoNumber}`, item.id));
      if (filteredNames.length > 1) {
        if (index < (filteredNames.length) - 1) {
          a.push(', ');
        }
      }
      return a;
    }, []);
    return workflowNames;
  }

  renderLoading(): React.ReactNode {
    return <div>Loading...</div>;
  }

  renderContent(): React.ReactNode {
    if (this.state.isLoading) {
      return this.renderLoading();
    }

    return (
      <div className="tbl-content">
        <div className="wigt-header">Project Delay</div>
        {
          !this.state.data || (this.state.data && this.state.data.length <= 0)
            ? <div className="tbl-nodata">No Data available</div>
            : (
              <div>
                <div className="pd-item">
                  <div className="tbl-header">Activities</div>
                  <div className="tbl-header">Linked workflows</div>
                  <div className="tbl-header">Delays</div>
                  <div className="tbl-header">Reasons</div>
                </div>
                {this.state.data.map((item: any) => (
                  <div className="pd-item">
                    <div className="tbl-items">
                      <div className="tbl-activityName">
                        {item.wbs}
                        {' '}
                        {item.name}
                      </div>
                      <div className="tbl-parentChain">{this.getParentHierarchy(item)}</div>
                    </div>
                    <div className="tbl-items">{this.getWorkflowDetails(item.linkedWorkflows)}</div>
                    <div className="tbl-redLabel">
                      {item.projectDelay}
                      {' '}
                      days
                    </div>
                    <div className="tbl-items">
                      {this.getReasonList(item.reasons)}
                    </div>
                  </div>
                ))}
              </div>
            )
        }
      </div>
    );
  }

  render(): React.ReactNode {
    return <div className="wigt-container">{this.renderContent()}</div>;
  }
}

export default ProjectDelay;
